import { Children, cloneElement } from 'react';
import { Frame, StaticContent } from "../components/FrameSwitcherChildren";
var checkIsFrame = function checkIsFrame(el) {
  return el.type === Frame || el.type.componentName === 'Frame';
};
var checkIsStatic = function checkIsStatic(el) {
  return el.type === StaticContent;
};
var checkIsOtherType = function checkIsOtherType(el) {
  return !(checkIsFrame(el) || checkIsStatic(el));
};
var filterNodes = function filterNodes(filterFn) {
  return function (node) {
    return Children.toArray(node).filter(function (el) {
      return el && filterFn(el);
    });
  };
};
var bindNodeKey = function bindNodeKey(filterFn) {
  return function (nodes) {
    return filterFn(nodes).map(function (el, key) {
      return /*#__PURE__*/cloneElement(el, {
        key: key
      });
    });
  };
};
export var filterFrame = bindNodeKey(filterNodes(checkIsFrame));
export var filterStatic = bindNodeKey(filterNodes(checkIsStatic));
export var filterOther = bindNodeKey(filterNodes(checkIsOtherType));